import React, { useCallback, useEffect, useMemo } from "react";

import {
  LOAD_EVENTS_V3_FETCH,
  unloadEventsV3Action,
} from "cortex/ui/src/fleet/redux-store/ui-state/events-v3/actions";
import { eventsV3Selector } from "cortex/ui/src/fleet/redux-store/ui-state/events-v3/selectors";
import { useAppDispatch, useAppSelector } from "cortex/ui/src/hooks";
import { createPromiseApiAction } from "cortex/ui/src/redux-store/api-sagas";
import {
  applicationsSelector,
  applicationsStoresLoadedSelector,
} from "cortex/ui/src/redux-store/applications/selectors";
import {
  deviceStoresLoadedSelector,
  devicesSelector,
} from "cortex/ui/src/redux-store/devices/selectors";
import { LoadingIndicator } from "cortex/ui/src/ui/loader";
import { Container } from "cortex/ui/src/view/layout";

import EventsTableContainer from "./EventsTableContainer";
import type { Event } from "../model";

export default function EventsList() {
  const dispatch = useAppDispatch();
  const emptyEvents: Event[] = [];
  const applications = useAppSelector(applicationsSelector);
  const applicationsStoresLoaded = useAppSelector(
    applicationsStoresLoadedSelector,
  );
  const devices = useAppSelector(devicesSelector);
  const devicesStoresLoaded = useAppSelector(deviceStoresLoadedSelector);
  const events = useAppSelector((state: any) => {
    return (
      (eventsV3Selector(state) as { events?: Event[] }).events ?? emptyEvents
    );
  });
  const storesLoaded = useMemo(
    () => applicationsStoresLoaded && devicesStoresLoaded,
    [applicationsStoresLoaded, devicesStoresLoaded],
  );

  const fetchEvents = useCallback(
    (serviceOpts: {
      start?: string;
      end?: string;
      filters?: Record<string, string[]>;
    }) => {
      return createPromiseApiAction(dispatch, LOAD_EVENTS_V3_FETCH, [
        serviceOpts.start,
        serviceOpts.end,
        serviceOpts.filters,
      ]) as Promise<{ data: { data: Event[] } }>;
    },
    [dispatch],
  );

  useEffect(() => {
    return () => {
      dispatch(unloadEventsV3Action());
    };
  }, [dispatch]);

  return (
    <Container gap={1} title="Events">
      {storesLoaded ? (
        <EventsTableContainer
          applications={applications}
          devices={devices}
          events={events}
          fetchMethod={fetchEvents}
        />
      ) : (
        <LoadingIndicator />
      )}
    </Container>
  );
}
